import React from "react";
import { ExternalLink, Newspaper, X, Loader2 } from "lucide-react";

/** Compact preview card (used in composer while typing and inside chat bubbles). */
export default function LinkPreviewCard({ preview, testid, compact = false, dark = false, onRemove, loading = false }) {
  if (loading && !preview) {
    return (
      <div data-testid={testid ? `${testid}-loading` : undefined} className="flex items-center gap-2 text-xs text-muted-foreground rounded-xl border px-3 py-2 mb-2">
        <Loader2 className="w-3.5 h-3.5 animate-spin" /> Gerando prévia do link...
      </div>
    );
  }
  if (!preview?.url) return null;
  let host = preview.source;
  try { host = host || new URL(preview.url).hostname; } catch { host = host || preview.url; }

  if (compact) {
    return (
      <a href={preview.url} target="_blank" rel="noopener noreferrer" data-testid={testid} onClick={(e) => e.stopPropagation()}
        className={`flex gap-2 rounded-xl overflow-hidden mb-1 border ${dark ? "bg-black/20 border-white/25 text-white" : "bg-muted/60 border-border"} hover:opacity-90 transition-opacity max-w-xs`}>
        {preview.image && <img src={preview.image} alt="" className="w-20 h-20 object-cover shrink-0" loading="lazy" />}
        <div className="p-2 min-w-0 flex-1">
          <div className={`text-[10px] uppercase tracking-wide font-semibold truncate ${dark ? "text-white/70" : "text-muted-foreground"}`}>{host}</div>
          <div className="font-semibold text-xs leading-snug line-clamp-2">{preview.title || preview.url}</div>
          {preview.description && <div className={`text-[11px] mt-0.5 line-clamp-2 ${dark ? "text-white/80" : "text-muted-foreground"}`}>{preview.description}</div>}
        </div>
      </a>
    );
  }

  return (
    <div className="relative mb-3" data-testid={testid ? `${testid}-wrap` : undefined}>
      {onRemove && (
        <button type="button" onClick={onRemove} aria-label="Remover prévia" data-testid={testid ? `${testid}-remove` : undefined}
          className="absolute top-2 right-2 z-10 w-7 h-7 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80">
          <X className="w-4 h-4" />
        </button>
      )}
      <a href={preview.url} target="_blank" rel="noopener noreferrer" data-testid={testid} onClick={(e) => e.stopPropagation()}
        className="block rounded-xl border overflow-hidden hover:border-primary/60 transition-colors bg-card">
        {preview.image ? (
          <img src={preview.image} alt="" className="w-full aspect-[16/9] object-cover" loading="lazy" />
        ) : (
          <div className="w-full aspect-[16/6] bg-gradient-to-br from-slate-800 to-slate-600 flex items-center justify-center text-white/70"><Newspaper className="w-8 h-8" /></div>
        )}
        <div className="p-3">
          <div className="flex items-center gap-1.5 text-[11px] text-muted-foreground uppercase tracking-wide font-semibold">
            {preview.favicon && <img src={preview.favicon} alt="" className="w-3.5 h-3.5 rounded-sm" onError={(e) => { e.currentTarget.style.display = "none"; }} />}
            {host}
          </div>
          <div className="font-bold text-sm leading-snug mt-1 line-clamp-2">{preview.title || preview.url}</div>
          {preview.description && <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{preview.description}</div>}
          <div className="text-[11px] text-primary font-semibold mt-2 flex items-center gap-1">Abrir link <ExternalLink className="w-3 h-3" /></div>
        </div>
      </a>
    </div>
  );
}
